import { X } from "react-feather";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

import "./Styles/Styles.scss";
const icon =
  require(`@src/assets/images/vyrill/icons/limit_reached.png`).default;

const LimitReached = ({ open, handleClose }) => {
  return (
    <Modal
      size="lg"
      isOpen={open}
      toggle={() => handleClose(!open, "limitReached")}
      className="Step3SuccessMessage Step2FetchDetails VideoProcess modal-dialog-centered"
    >
      <ModalHeader className="justify-content-end">
        <X
          size={30}
          role="button"
          onClick={() => handleClose(!open, "limitReached")}
        />
      </ModalHeader>
      <ModalBody>
        <>
          <div className="d-flex justify-content-center">
            <div>
              <img src={icon} width={100} />
            </div>
          </div>

          <div className="d-flex justify-content-center mt-4 mb-4">
            <h1 style={{ color: "black" }}>
              <b>Video Upload Limit Reached!</b>
            </h1>
          </div>

          <div className="d-flex justify-content-center mb-3">
            <h4 className="text-center" style={{ color: "black" }}>
              We can help you add more videos to your dashboard.
              <br />
              <br />
              Contact us at{" "}
              <span style={{ color: "#783AD0" }}>
                <a href="mailto:sales@vyrill.com">sales@vyrill.com</a>{" "}
              </span>
              to upgrade your plan.
            </h4>
          </div>
        </>
      </ModalBody>
    </Modal>
  );
};

export default LimitReached;
